import React from 'react'
import { TextItem } from './TextItem'
import { JSONFormViewComp, SchemaElementTypeMap } from 'redux/types/schemaView.type'

export const RadioView: React.FC<JSONFormViewComp<SchemaElementTypeMap['radio']>> = React.memo(({ node }) => {
    if (!node.isVisible || !node.isVisibleInWeb || node.value === undefined) return null

    return <TextItem direction="row" label={node.label} value={node.value} isLabelVisible={node.isLabelVisible} />
})
